<ion-list>

    <ion-list-header>
        <ion-label>{{ 'Weather update' | translate }}</ion-label>
    </ion-list-header>

    <ion-item lines="none">
        <ion-label>
             {{ 'Local weather' | translate }}
            <ion-text style="font-size: small" color="medium" class="ion-text-wrap">
                <br /> {{ 'We will find where you are' | translate }}
            </ion-text>
        </ion-label>
        <ion-toggle [(ngModel)]="isWeatherAvailable" slot="end" #localWeather></ion-toggle>
    </ion-item>

    <ion-button [disabled]="!localWeather.checked || isUpdating" class="ion-margin" (click)="getCurrentWeather()" expand="block">
        <span *ngIf="!isUpdating">{{ 'Update' | translate }} </span>
        <ion-spinner *ngIf="isUpdating" name="crescent"></ion-spinner>
    </ion-button>

</ion-list>